<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Telegram Manager
  .container.mt-5
    .row
      .col
        .white_block Для быстрого управления нашими сервисами используйте наш Telegram-бот.
          br
          | Он простоянно обновляется, чтобы стать ещё удобней!
          br
          br
          b Найдите его в Telegram: @hub_manager_bot
          br
          br
          | При первом знакомстве он запросит Ваш API-ключ.
          .api
            .apiKeyLabel Ваш API-ключ:
              .apiKey 
                span(v-if="hide_api_key")
                  i.far.fa-eye(@click="hide_api_key = !hide_api_key")
                  | XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
                span(v-if="!hide_api_key")
                  i.far.fa-eye-slash(@click="hide_api_key = !hide_api_key")
                  | {{ api_key }}
</template>
<script>
import moment from "moment";
import apiDriver from "../apiDriver";

export default {
  components: {},

  data() {
    return {
      hide_api_key: true,
      api_key: "",
    };
  },

  computed: {},

  mounted() {
    this.api_key = this.$store.state.userData.user.api_key;
  },

  methods: {},
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.main_amount {
  font-size: 26pt;
}

a {
  color: black;
}
</style>
